function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#036FE2",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.5142 15.2275l1.414-1.414-.707-.707c-.39-.39-.39-1.024 0-1.414l8.486-8.485a.9892.9892 0 01.706-.293c.268 0 .518.104.708.293l.706.707 1.415-1.414-.707-.707c-1.133-1.133-3.111-1.133-4.243 0l-8.485 8.485c-1.17 1.17-1.17 3.073 0 4.242l.707.707zM20.1919 7.4512l-.707-.707-1.415 1.415.708.707c.189.189.292.439.292.707 0 .265-.104.517-.292.705l-8.485 8.486c-.378.377-1.037.377-1.415 0l-.707-.707-1.414 1.414.707.707c.567.567 1.32.879 2.121.879.802 0 1.555-.312 2.122-.879l8.485-8.486c.566-.566.878-1.32.878-2.119 0-.802-.312-1.556-.878-2.122M13.1206 10.2788l-1.414-1.414 7.071-7.071 1.414 1.414zM3.2212 20.1777l-1.414-1.414 7.071-7.071 1.414 1.414z"
}));

var SvgLinkIcon = function SvgLinkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkIcon.d73a8a49.svg";
export { ForwardRef as ReactComponent };